import { render } from "./StudentParametersBlock.vue?vue&type=template&id=77d1174f&scoped=true"
import script from "./StudentParametersBlock.vue?vue&type=script&lang=js"
export * from "./StudentParametersBlock.vue?vue&type=script&lang=js"

import "./StudentParametersBlock.vue?vue&type=style&index=0&id=77d1174f&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d1174f"]])

export default __exports__